var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['relative flex items-center justify-center text-center cursor-default', _vm.boxClass],style:({
    background: _vm.backgroundStyle,
    opacity: _vm.isSelected ? 1 : 0.6,
  })},[_c('span',{staticClass:"text-sm",class:{ 'text-white': _vm.isSelected, 'text-gray-400': !_vm.isSelected }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }